import type { ReactNode } from 'react';
import cx from 'clsx';
import { AdditionalNotesPlaceholder } from '../placeholders';
import styles from './additional-notes.module.css';

interface AdditionalNotesProps {
  message?: string;
  position: 'header' | 'footer';
}

export function AdditionalNotes({ message, position }: AdditionalNotesProps): ReactNode {
  return (
    <AdditionalNotesPlaceholder position={position}>
      {message ? (
        <p
          className={cx('body-1', 'mb-8', styles.notes)}
          data-testid={`pdf-preview-additional-notes-${position}`}
        >
          {message}
        </p>
      ) : null}
    </AdditionalNotesPlaceholder>
  );
}
